import capitalizeFirstLetter from '@/helpers/capitalizeFirstLetter';

export default {
  namespaced: true,
  state: {
    selectedTransfer: null,
    orderUuid: null,
  },
  getters: {
    getSelectedTransfer(state) {
      return capitalizeFirstLetter(state.selectedTransfer);
    },
    getOrderUuid(state) {
      return state.orderUuid;
    },
  },
  mutations: {
    setSelectedTransfer(state, payload) {
      state.selectedTransfer = payload;
    },
    resetSelectedTransfer(state) {
      state.selectedTransfer = null;
    },
    setOrderUuid(state, payload) {
      state.orderUuid = payload;
    },
  },
};
